import React from 'react';
import { formatApy, formatTvl, formatScore, getPoolsUrl } from './utils';

export default function PoolsList({ pools, sortBy }) {
  if (pools.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-12 text-center text-gray-500">
        No pools found
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <h2 className="text-lg font-semibold text-gray-900">
          Pools ({pools.length})
        </h2>
      </div>
      <div className="divide-y divide-gray-200">
        {pools.map((pool, index) => {
          const metadata = pool.pool_metadata || {};
          const tvl = metadata.tvlUsd || null;
          const protocol = {
            id: pool.protocol_id,
            name: pool.protocol_name,
            slug: pool.protocol_slug,
            logo: pool.protocol_logo,
            score: pool.protocol_score
          };

          return (
            <div key={pool.id || index} className="p-6 hover:bg-gray-50 transition-colors">
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                {/* Protocol Info */}
                <div className="flex items-center gap-3 min-w-0 flex-1">
                  {protocol.logo && (
                    <img
                      src={protocol.logo}
                      alt={`${protocol.name} logo`}
                      className="w-12 h-12 rounded-lg border border-gray-200 object-cover bg-gray-50 flex-shrink-0"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Crect width='48' height='48' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='20' fill='%239ca3af'%3E" + (protocol.name?.charAt(0)?.toUpperCase() || '?') + "%3C/text%3E%3C/svg%3E";
                      }}
                    />
                  )}
                  <div className="min-w-0 flex-1">
                    <h3 className="text-base font-semibold text-gray-900 truncate">
                      {protocol.name || "Unknown Protocol"}
                    </h3>
                    <div className="flex items-center gap-2 flex-wrap mt-1">
                      {pool.token_symbol && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700">
                          {pool.token_symbol}
                        </span>
                      )}
                      {pool.chain && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700">
                          {pool.chain}
                        </span>
                      )}
                      {protocol.score !== null && protocol.score !== undefined && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-purple-50 text-purple-700">
                          Score: {formatScore(protocol.score)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* APY Info */}
                <div className="flex-shrink-0 text-right">
                  <div className="text-2xl font-bold text-green-600 mb-1">
                    {formatApy(pool.apy)}
                  </div>
                  <div className="text-xs text-gray-500">
                    APY
                  </div>
                </div>

                {/* TVL */}
                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-semibold text-gray-900 mb-1">
                    {formatTvl(tvl)}
                  </div>
                  <div className="text-xs text-gray-500">
                    TVL
                  </div>
                </div>

                {/* Go Button */}
                <div className="flex-shrink-0">
                  <a
                    href={getPoolsUrl(protocol.slug)}
                    className="px-4 py-2 rounded-lg text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors inline-block"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

